import type { Translate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";

import type { IWebEntity } from "./types";

export const TRACKING_WIZARD = "Campaign Creation";
export const TRACKING_SETTINGS = "Campaign Settings";

export const entitiesObject = {
    googleBusinessProfiles: "GBP",
    youTubeChannels: "Youtube",
    tikTokChannels: "TikTok",
    twitterAccounts: "Twitter",
} as const;

export const entitiesArray = {
    GBP: "googleBusinessProfiles",
    Youtube: "youTubeChannels",
    TikTok: "tikTokChannels",
    Twitter: "twitterAccounts",
} as const;

const WEB_ENTITY_I18N_KEYS: Record<keyof typeof entitiesObject, { text: string, chipText: string }> = {
    googleBusinessProfiles: {
        text: "rankTracker.webEntities.channelName.google.text",
        chipText: "rankTracker.webEntities.channelName.google.chipText",
    },
    youTubeChannels: {
        text: "rankTracker.webEntities.channelName.youtube.text",
        chipText: "rankTracker.webEntities.channelName.youtube.chipText",
    },
    tikTokChannels: {
        text: "rankTracker.webEntities.channelName.tiktok.text",
        chipText: "rankTracker.webEntities.channelName.tiktok.chipText",
    },
    twitterAccounts: {
        text: "rankTracker.webEntities.channelName.twitter.text",
        chipText: "rankTracker.webEntities.channelName.twitter.chipText",
    },
};

export const availableWebEntities = (translateFn: Translate): IWebEntity[] => [
    {
        id: "googleBusinessProfiles",
        text: translateFn(WEB_ENTITY_I18N_KEYS.googleBusinessProfiles.text),
        chipText: translateFn(WEB_ENTITY_I18N_KEYS.googleBusinessProfiles.chipText),
        iconName: "google-search",
        iconSize: "sm",
        iconColor: colorsPalettes.carbon[200],
    },
    {
        id: "youTubeChannels",
        text: translateFn(WEB_ENTITY_I18N_KEYS.youTubeChannels.text),
        chipText: translateFn(WEB_ENTITY_I18N_KEYS.youTubeChannels.chipText),
        iconName: "youtube",
        iconSize: "sm",
        iconColor: colorsPalettes.carbon[200],
    },
    {
        id: "tikTokChannels",
        text: translateFn(WEB_ENTITY_I18N_KEYS.tikTokChannels.text),
        chipText: translateFn(WEB_ENTITY_I18N_KEYS.tikTokChannels.chipText),
        iconName: "ticktok",
        iconSize: "sm",
        iconColor: colorsPalettes.carbon[200],
    },
    {
        id: "twitterAccounts",
        text: translateFn(WEB_ENTITY_I18N_KEYS.twitterAccounts.text),
        chipText: translateFn(WEB_ENTITY_I18N_KEYS.twitterAccounts.chipText),
        iconName: "social-twitter",
        iconSize: "sm",
        iconColor: colorsPalettes.carbon[200],
    },
];
